import { IMealPlanTemplate } from "../../types/plan";
import { getApi } from "../api";
import { PlanTemplateDb } from "../indexeddb/planTemplateDb";
import { getStringFromLocalStorage } from "../localStorage";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiToken = getStringFromLocalStorage("idToken");

export class PlanTemplateStore {
  private static instance: PlanTemplateStore | null = null;
  private _readyPromise: Promise<void>;
  private db = new PlanTemplateDb();
  public planTemplates: number[] = [];
  public planTemplateItems: IMealPlanTemplate[] = [];
  private constructor() {
    this._readyPromise = this.load();
  }

  public static getInstance(): PlanTemplateStore {
    if (!PlanTemplateStore.instance) {
      PlanTemplateStore.instance = new PlanTemplateStore();
    }
    return PlanTemplateStore.instance;
  }

  public ready(): Promise<void> {
    return this._readyPromise;
  }

  private async load(): Promise<void> {
    await this.db.initDB();
    await this.getPlanTemplates();
  }

  public async getPlanTemplates(clear: boolean = false): Promise<void> {
    try {
      const local = await this.db.getPlanTemplates();
      if (local.length === 0 || clear) {
        const api = await getApi(apiUrl, "mealplantemplate", apiToken);
        await this.db.addPlanTemplates(api, clear);
        this.planTemplateItems = api;
      } else {
        this.planTemplateItems = local;
      }
      this.planTemplates = [...new Set(this.planTemplateItems.map((planTemplate) => planTemplate.template_id))];
    } catch (e: any) {
      console.log(e);
    }
  }

  // public async getEmptyRecipes(): Promise<void> {
  //   try {
  //     const api = await getApi(apiUrl, "recipe", apiToken, { empty: "true" });
  //     this.emptyRecipes = api;
  //   } catch (e: any) {
  //     console.log(e);
  //   }
  // }

  // public async addRecipe(recipeName: string, defaultPeople: number): Promise<void> {
  //   try {
  //     await postApi(apiUrl, "recipe", { name: recipeName, default_people: defaultPeople }, apiToken);
  //     this.getHouseholdRecipes(true);
  //   } catch (e: any) {
  //     console.log(e);
  //   }
  // }
}
